/**
 * QR Code Generator utility
 */
export async function generateQRDataURL(text, size = 200) {
  const QRCode = (await import('qrcode')).default;
  return QRCode.toDataURL(text, {
    width: size,
    margin: 1,
    color: { dark: '#0f172a', light: '#ffffff' },
  });
}

export function getVerificationURL(verificationId) {
  const base = import.meta.env.VITE_APP_URL || window.location.origin;
  return `${base}/#/verify/${verificationId}`;
}
